import Swal from "sweetalert2";

/**
 * YvooaInfoModal - A reusable component to display Yvooa branding information
 * in a styled modal that adapts to light and dark themes using Tailwind CSS
 */

const YvooaInfoModal = () => {
  const isDarkMode = document.documentElement.classList.contains("dark");
  const backdropColor = isDarkMode
    ? "rgba(0, 0, 0, 0.7)"
    : "rgba(0, 0, 0, 0.3)";

  Swal.fire({
    html: `
      <div class="animate-slideDown px-14 py-8 rounded-xl bg-white dark:bg-slate-900/95 border border-blue-500/20 dark:border-slate-400/20 backdrop-blur-sm dark:backdrop-blur-md w-full max-w-lg mx-auto shadow-[0_20px_60px_rgba(59,130,246,0.15),0_10px_20px_rgba(0,0,0,0.08)] dark:shadow-[0_10px_40px_rgba(0,0,0,0.5)]">
        <!-- Logo Icon -->
        <div class="flex justify-center mb-4 animate-pulse">
          <svg
            viewBox="0 0 100 100"
            width="80"
            height="80"
            role="img"
            aria-label="Yvooa"
            class="drop-shadow-[0_10px_25px_rgba(25,118,210,0.3)]"
          >
            <defs>
              <radialGradient id="premiumGrad" cx="50%" cy="30%">
                <stop offset="0%" stop-color="#60a5fa" />
                <stop offset="50%" stop-color="#3b82f6" />
                <stop offset="100%" stop-color="#1e40af" />
              </radialGradient>
              <linearGradient id="goldenGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stop-color="#fbbf24" />
                <stop offset="100%" stop-color="#f59e0b" />
              </linearGradient>
              <filter id="glow">
                <feGaussianBlur stdDeviation="3" result="coloredBlur" />
                <feMerge>
                  <feMergeNode in="coloredBlur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            <circle cx="50" cy="50" r="48" fill="url(#premiumGrad)" filter="url(#glow)" />
            <polygon points="48,92 62,18 78,18" fill="#ffffff" filter="url(#glow)" />
            <polygon points="22,18 50,48 45,70" fill="url(#goldenGrad)" filter="url(#glow)" />
          </svg>
        </div>

        <!-- Title -->
        <h2 class="text-2xl font-bold text-blue-900 dark:text-blue-400 mb-2 text-center tracking-tight">
          Yvooa
        </h2>

        <!-- Tagline -->
        <p class="text-sm font-semibold text-gray-900 dark:text-gray-100 text-center mb-1 tracking-wide">
          Property Management
        </p>

        <!-- Main slogan -->
        <p class="text-sm font-semibold text-blue-700 dark:text-blue-300 text-center mb-3 tracking-wide">
          All Your Solutions under one roof.
        </p>

        <!-- Subtitle -->
        <p class="text-xs text-slate-600 dark:text-slate-400 font-medium text-center tracking-wide">
          Your Complete Property Management Platform
        </p>
      </div>
    `,
    showConfirmButton: false,
    allowOutsideClick: true,
    allowEscapeKey: true,
    background: "transparent",
    padding: "0",
    width: "auto",
    customClass: {
      popup: "!bg-transparent !shadow-none !p-0",
      htmlContainer: "!m-0 !p-0",
    },
    backdrop: backdropColor,
    didOpen: (modal) => {
      setTimeout(() => {
        modal.hideLoading();
      }, 4000);
    },
  });
};

export default YvooaInfoModal;
